export default __webpack_public_path__ + "static/media/24-FarmhouseInSanCasciano.c50b9085.jpeg";